import React from "react";

const RatiosCles = () => {
  return (
    <div className="ratios-cles">
      <h2>Ratios clés</h2>
      <p>Calcul et affichage des ratios financiers clés.</p>
    </div>
  );
};

export default RatiosCles;
